"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformVideoInput = exports.transformVideoDevice = exports.stopTransformationAndGetIntrinsicDevice = exports.resetTransformedVideoInput = exports.isBrowserSupported = exports.getVideoFxConfig = void 0;
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
var _reactDeviceDetect = require("react-device-detect");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var logger = new _StudioLogger.StudioLogger('transformVideoDevice');
var blurUtilsLogger = new _StudioLogger.StudioLogger('blurUtils');
// creating it here as it is required to be passed to blur utility methods at chime's end
var chimeLogger = new _amazonChimeSdkJs.ConsoleLogger('chimeBlurLogger', _amazonChimeSdkJs.LogLevel.INFO);

/*
      Defines the videoConfig settings
        1. backgroundBlur.isEnabled: Blur background is enabled if true
        2. backgroundBlur.strength: strength of blur background. Three possible values are 'low' | 'medium' | 'high'
      The following settings are not related to blur functionality and they are related to background replacement but
      it's a required value for this object so passed some dummy values
        1. backgroundReplacement.isEnabled: Background replacement is enabled if true
        2. backgroundReplacement.backgroundImageURL: Image url to be used for background replacement
        3. backgroundReplacement.defaultColor: Default color for background replacement
       */
var videoFxConfig = {
  backgroundBlur: {
    isEnabled: true,
    strength: 'high'
  },
  backgroundReplacement: {
    isEnabled: false,
    backgroundImageURL: 'notdefined.jpg',
    defaultColor: undefined
  }
};

/**
 * Checks if a browser & version is supported for blur background feature
 * @return {Promise<boolean>}
 */
var isBrowserSupported = exports.isBrowserSupported = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _amazonChimeSdkJs.VideoFxProcessor.isSupported(chimeLogger, false);
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function isBrowserSupported() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Checks if the browser supports blur background feature
 * @returns {Promise<boolean>}
 */
var checkBrowserSupport = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var isSupported;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return isBrowserSupported();
        case 2:
          isSupported = _context2.sent;
          if (isSupported) {
            _context2.next = 5;
            break;
          }
          throw new Error("Background blur is not supported for browser ".concat(_reactDeviceDetect.browserName, " version ").concat(_reactDeviceDetect.browserVersion));
        case 5:
          return _context2.abrupt("return", isSupported);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function checkBrowserSupport() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 *
 * @param filterType
 * @param backgroundImageURL
 * @returns {{backgroundReplacement: {defaultColor: string, isEnabled: boolean, backgroundImageURL: string}, backgroundBlur: {strength: string, isEnabled: boolean}}}
 */
var getVideoFxConfig = exports.getVideoFxConfig = function getVideoFxConfig(filterType) {
  var backgroundImageURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    backgroundBlur: {
      isEnabled: filterType === _VirtualBackground.BACKGROUND_OPTIONS.BLUR,
      strength: 'high'
    },
    backgroundReplacement: {
      isEnabled: filterType === _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM,
      backgroundImageURL: backgroundImageURL,
      defaultColor: backgroundImageURL ? undefined : '#5C617C'
    }
  };
};

/**
 * Transforms the video input
 * @param videoInputDevice
 * @param videoFxConfig
 * @returns {Promise<DefaultVideoTransformDevice>}
 */
var transformVideoInput = exports.transformVideoInput = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(videoInputDevice, videoFxConfig) {
    var vfxProcessor, transformedVideoDevice;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return checkBrowserSupport();
        case 2:
          _context3.next = 4;
          return setupProcessor(videoFxConfig);
        case 4:
          vfxProcessor = _context3.sent;
          transformedVideoDevice = new _amazonChimeSdkJs.DefaultVideoTransformDevice(chimeLogger, videoInputDevice, [vfxProcessor]); // we need to set this to 30 or else it will default to 15 fps
          transformedVideoDevice.framerate = 30;
          logger.info('Video Input transform successful', {
            videoFxConfig: videoFxConfig,
            videoInputDevice: videoInputDevice
          });
          return _context3.abrupt("return", transformedVideoDevice);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function transformVideoInput(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Resets the view input
 * @param transformedVideoDevice
 * @returns {Promise<*>}
 */
var resetTransformedVideoInput = exports.resetTransformedVideoInput = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(transformedVideoDevice) {
    var intrinsicDevice;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return transformedVideoDevice.intrinsicDevice();
        case 2:
          intrinsicDevice = _context4.sent;
          _context4.next = 5;
          return transformedVideoDevice.stop();
        case 5:
          logger.info('Video Input transform reset successful.', {
            intrinsicDevice: intrinsicDevice
          });
          return _context4.abrupt("return", intrinsicDevice);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function resetTransformedVideoInput(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Setup the processor to apply video filters to the chime video
 * @param videoFxConfig Configuration settings
 * @return {Promise<VideoFxProcessor>} The processor object
 */
var setupProcessor = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(videoFxConfig) {
    var retry,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          retry = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;
          _context5.prev = 1;
          _context5.next = 4;
          return _amazonChimeSdkJs.VideoFxProcessor.create(chimeLogger, videoFxConfig);
        case 4:
          return _context5.abrupt("return", _context5.sent);
        case 7:
          _context5.prev = 7;
          _context5.t0 = _context5["catch"](1);
          if (!retry) {
            _context5.next = 15;
            break;
          }
          blurUtilsLogger.info("setupProcessor - Error creating VideoFxProcessor. Retrying Once. Error: ".concat(_context5.t0), {});
          _context5.next = 13;
          return setupProcessor(videoFxConfig, false);
        case 13:
          _context5.next = 17;
          break;
        case 15:
          blurUtilsLogger.error("setupProcessor - Error creating VideoFxProcessor. Not retrying. Error: ".concat(_context5.t0), {});
          throw new Error('Error creating VideoFxProcessor');
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[1, 7]]);
  }));
  return function setupProcessor(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * @deprecated - use transformVideoInput instead - To be removed here - WEBINAR-37005
 * Transforms the video on the basis of video input device
 * @param videoInputDevice Device id of the video input device
 * @return {Promise<VideoTransformDevice>} The transformed device
 */
var transformVideoDevice = exports.transformVideoDevice = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(videoInputDevice) {
    var transformDevice, vfxProcessor;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          // Declare a transform device object
          transformDevice = null;
          _context6.prev = 1;
          _context6.next = 4;
          return isBrowserSupported();
        case 4:
          if (_context6.sent) {
            _context6.next = 8;
            break;
          }
          blurUtilsLogger.info("Background blur is not supported for browser ".concat(_reactDeviceDetect.browserName, " version ").concat(_reactDeviceDetect.browserVersion), '');
          _context6.next = 12;
          break;
        case 8:
          _context6.next = 10;
          return setupProcessor(videoFxConfig);
        case 10:
          vfxProcessor = _context6.sent;
          transformDevice = new _amazonChimeSdkJs.DefaultVideoTransformDevice(chimeLogger, videoInputDevice, [vfxProcessor]);
        case 12:
          _context6.next = 17;
          break;
        case 14:
          _context6.prev = 14;
          _context6.t0 = _context6["catch"](1);
          blurUtilsLogger.error('An error occurred while starting blur background process in transformVideoDevice', _context6.t0);
        case 17:
          return _context6.abrupt("return", transformDevice);
        case 18:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[1, 14]]);
  }));
  return function transformVideoDevice(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * @deprecated - use resetTransformedVideoInput instead - To be removed here - WEBINAR-37005
 * This function is used to gracefully stop the Vfx transformation stream to release all the resources on user's system
 * @param transformedVideoDevice The transformed device
 * @return Intrinsic device
 */
var stopTransformationAndGetIntrinsicDevice = exports.stopTransformationAndGetIntrinsicDevice = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(transformedVideoDevice) {
    var intrinsicDevice;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          // Intrinsic device is the base video device on which the video transformation is applied. So it's a plain root device
          // which doesn't have vfx effects applied upon.
          intrinsicDevice = null;
          _context7.prev = 1;
          if (!transformedVideoDevice) {
            _context7.next = 10;
            break;
          }
          _context7.next = 5;
          return transformedVideoDevice.intrinsicDevice();
        case 5:
          intrinsicDevice = _context7.sent;
          _context7.next = 8;
          return transformedVideoDevice.stop();
        case 8:
          _context7.next = 11;
          break;
        case 10:
          blurUtilsLogger.error('unable to stop transformation stream since video device is not found', '');
        case 11:
          _context7.next = 16;
          break;
        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](1);
          blurUtilsLogger.error('An error occurred while stopping blur background process in transformVideoDevice', _context7.t0);
        case 16:
          return _context7.abrupt("return", intrinsicDevice);
        case 17:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[1, 13]]);
  }));
  return function stopTransformationAndGetIntrinsicDevice(_x6) {
    return _ref7.apply(this, arguments);
  };
}();